import React from "react";
import {
	List,
	SimpleList,
	useRecordContext
} from "react-admin";
import Avatar from "@mui/material/Avatar";

const RegionAvatar = () => {
	const record = useRecordContext()
	return (
		<Avatar>
			{record.region_name
				.split(" ")
				.map((e) => e[0])
				.join("")}
		</Avatar>
	)
};

const RegionList = (props) => (
	<List {...props} title={"NACS Regions"} sort={{ field: "id", order: "DESC" }}>
		<SimpleList
			primaryText={record => record.region_name}
			secondaryText={record => record.states.join(', ')}
            leftAvatar={record => <RegionAvatar record={record} />}
			linkType="edit"
		/>
	</List>
);

export default RegionList;
